import { render, staticRenderFns } from "./scene4animation.vue?vue&type=template&id=5c783e83&scoped=true&"
import script from "./scene4animation.vue?vue&type=script&lang=js&"
export * from "./scene4animation.vue?vue&type=script&lang=js&"
import style0 from "./scene4animation.vue?vue&type=style&index=0&id=5c783e83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c783e83",
  null
  
)

export default component.exports